import { memo } from 'react';
import { LeaveFamilyTogetherTemplate } from 'components/templates/LeaveFamilyTogetherTemplate';

type Props = {};

export const LeaveFamilyTogether = memo((_props: Props) => {
	return <LeaveFamilyTogetherTemplate />;
});
